import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
const jwt = require('jsonwebtoken');

//Validaciones
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import firebase from "firebase/app";
/* Add firebase auth */
require("firebase/auth");
require("firebase/firestore");
require("firebase/storage");
//require("firebase/database");
//require("firebase/messaging");
//require("firebase/functions");

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyABOLJbwCqhZLsIepIBi1bV9Bcw9d9GflM",
  authDomain: "abonos-ce9dc.firebaseapp.com",
  databaseURL: "https://abonos-ce9dc.firebaseio.com",
  projectId: "abonos-ce9dc",
  storageBucket: "abonos-ce9dc.appspot.com",
  messagingSenderId: "331412583493",
  appId: "1:331412583493:web:5a368ef020a5fdd7395f2c"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const storage = firebaseApp.storage();
export {db, storage}

Vue.config.productionTip = false

firebase.auth().onAuthStateChanged(function(user) {
  /* Authenticacion */
  if (user) {
    store.dispatch('detectarUsuario', {email: user.email, uid: user.uid})
  } else {
    store.dispatch('detectarUsuario', null)
  }
  
  /* Carga de Aplicacion */
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')

});


